(() => {
  const CATEGORY_ORDER = ['adult_solo', 'adult_sharing', 'child_without_bed', 'child_with_bed', 'infant'];
  const CATEGORY_LABELS = {
    adult_solo: 'Adult – Single/Solo',
    adult_sharing: 'Adult – Sharing',
    child_with_bed: 'Child – with bed',
    child_without_bed: 'Child – without bed',
    infant: 'Infant'
  };
  const CATEGORY_START_AGE = { adult: 30, child_with_bed: 7, child_without_bed: 7, infant: 1 };
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dateKey = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const parseDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const formatDate = (date) => date.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });
  const monthIndex = (date) => (date.getFullYear() * 12) + date.getMonth();
  const clampCount = (value) => Math.max(0, Math.floor(Number(value) || 0));
  const calendarValue = (input) => input?.closest('[data-at-calendar]')?.dataset.calendarValue || input?.value || '';

  const categoryFromTitle = (title) => {
    const value = String(title || '').toLowerCase().replace(/[–—]/g, '-');
    if (value.includes('infant')) return 'infant';
    if (value.includes('child') && (value.includes('without mattress') || value.includes('without bed') || value.includes('no bed'))) return 'child_without_bed';
    if (value.includes('child') && (value.includes('with mattress') || value.includes('with bed') || value.includes('extra bed'))) return 'child_with_bed';
    if (value.includes('child')) return 'child_with_bed';
    if (value.includes('adult') && (value.includes('single') || value.includes('solo'))) return 'adult_solo';
    if (value.includes('adult') && value.includes('sharing')) return 'adult_sharing';
    if (value.includes('adult')) return 'adult_sharing';
    return null;
  };

  const CustomCalendar = window.ATCustomCalendar;

  const calendarMarkup = (name, label, mode, category) => `
    <label class="at-booking-field at-date-field">
      <span>${label} *</span>
      <div class="at-date-picker" data-at-calendar data-calendar-mode="${mode}" data-calendar-category="${category}">
        <button class="at-date-picker__trigger" type="button" aria-haspopup="dialog" aria-expanded="false" data-at-calendar-trigger><span data-at-calendar-label>dd/mm/yyyy</span><span aria-hidden="true">▣</span></button>
        <input type="hidden" name="${name}" data-at-calendar-input>
        <div class="at-date-picker__panel" role="dialog" aria-label="Choose ${label.toLowerCase()}" data-at-calendar-panel hidden>
          <div class="at-date-picker__header"><button type="button" aria-label="Previous month" data-at-calendar-previous>←</button><div class="at-date-picker__jump"><select data-at-calendar-month aria-label="Month"></select><select data-at-calendar-year aria-label="Year"></select></div><button type="button" aria-label="Next month" data-at-calendar-next>→</button></div>
          <div class="at-date-picker__weekdays" aria-hidden="true"><span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span></div>
          <div class="at-date-picker__days" role="grid" data-at-calendar-days></div>
          <p class="at-date-picker__help">${mode === 'dob' ? (category === 'infant' ? 'Birth dates older than 1 year are unavailable.' : category === 'child' ? 'Birth dates older than 11 years are unavailable.' : 'Future birth dates are unavailable.') : 'Expired passports cannot be selected.'}</p>
        </div>
      </div>
    </label>`;

  const initGallery = (root) => {
    const gallery = root.matches?.('[data-at-gallery]') ? root : root.querySelector('[data-at-gallery]');
    if (!gallery) return;
    if (gallery.dataset.atGalleryReady === 'true') return;
    gallery.dataset.atGalleryReady = 'true';
    const slides = [...gallery.querySelectorAll('[data-at-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-at-gallery-thumb]')];
    const currentNode = gallery.querySelector('[data-at-gallery-current]');
    const thumbTrack = gallery.querySelector('[data-at-gallery-thumbs]');
    const viewer = gallery.querySelector('[data-at-gallery-viewer]');
    if (slides.length < 2) {
      if (currentNode) currentNode.textContent = '1';
      return;
    }
    let current = 0;
    let pointerStart = null;
    let autoplayTimer = null;
    const autoplay = gallery.dataset.atGalleryAutoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayInterval = Math.max(3000, Number(gallery.dataset.atGalleryInterval) || 5000);

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
      });
      if (currentNode) currentNode.textContent = String(current + 1);
      const activeThumb = thumbs[current];
      if (activeThumb && thumbTrack) {
        const target = activeThumb.offsetLeft - ((thumbTrack.clientWidth - activeThumb.offsetWidth) / 2);
        thumbTrack.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    };

    const stopAutoplay = () => {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };
    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay || document.hidden) return;
      autoplayTimer = window.setInterval(() => show(current + 1), autoplayInterval);
    };
    const navigate = (index) => {
      show(index);
      startAutoplay();
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => navigate(index)));
    gallery.querySelector('[data-at-gallery-previous]')?.addEventListener('click', () => navigate(current - 1));
    gallery.querySelector('[data-at-gallery-next]')?.addEventListener('click', () => navigate(current + 1));
    gallery.querySelector('[data-at-thumbs-previous]')?.addEventListener('click', () => thumbTrack?.scrollBy({ left: -Math.max(260, thumbTrack.clientWidth * .75), behavior: 'smooth' }));
    gallery.querySelector('[data-at-thumbs-next]')?.addEventListener('click', () => thumbTrack?.scrollBy({ left: Math.max(260, thumbTrack.clientWidth * .75), behavior: 'smooth' }));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') navigate(current - 1);
      if (event.key === 'ArrowRight') navigate(current + 1);
    });
    viewer?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('video, iframe, model-viewer, button')) return;
      pointerStart = event.clientX;
    });
    viewer?.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const movement = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(movement) < 45) return;
      navigate(current + (movement < 0 ? 1 : -1));
    });
    viewer?.addEventListener('pointercancel', () => { pointerStart = null; });
    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);
    gallery.addEventListener('focusin', stopAutoplay);
    gallery.addEventListener('focusout', (event) => {
      if (!gallery.contains(event.relatedTarget)) startAutoplay();
    });
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
    show(0);
    startAutoplay();
  };

  const configuredOffset = (root) => Number.parseInt(getComputedStyle(root).getPropertyValue('--at-sticky-offset'), 10) || 0;

  const visibleHeaderOffset = (root) => {
    const selectors = [
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      'header[role="banner"]',
      '[data-header]'
    ];
    let offset = 0;
    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      if (root.contains(element)) return;
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      const rect = element.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top <= 2) offset = Math.max(offset, rect.bottom);
    });
    return Math.max(configuredOffset(root), Math.ceil(offset));
  };

  const combinedStickyOffset = (root) => visibleHeaderOffset(root);

  const scrollToTarget = (root, target, focus = false, instant = false) => {
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - combinedStickyOffset(root) - 18;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    if (focus) window.setTimeout(() => target.focus?.({ preventScroll: true }), 450);
  };

  const initBooking = (root, productData) => {
    const form = root.querySelector('[data-at-booking-form]');
    if (!form) return;

    const roomsNode = form.querySelector('[data-at-rooms]');
    const addRoom = form.querySelector('[data-at-add-room]');
    const roomSummary = form.querySelector('[data-at-room-summary]');
    const travellerSection = form.querySelector('[data-at-traveller-section]');
    const travellerSummary = form.querySelector('[data-at-traveller-summary]');
    const travellerStepNumber = form.querySelector('[data-at-traveller-step-number]');
    const travellersNode = form.querySelector('[data-at-travellers]');
    const contactSection = form.querySelector('[data-at-booking-contact]');
    const departure = form.querySelector('[data-at-departure]');
    const totalNode = root.querySelector('[data-at-total]');
    const totalGuestsNode = root.querySelector('[data-at-total-guests]');
    const selectedNode = root.querySelector('[data-at-selected-variants]');
    const submit = root.querySelector('[data-at-submit]');
    const error = form.querySelector('[data-at-error]');
    const dock = root.querySelector('[data-at-booking-dock]');
    const dockTotal = root.querySelector('[data-at-dock-total]');
    const dockGuests = root.querySelector('[data-at-dock-guests]');
    const dockBook = root.querySelector('[data-at-dock-book]');
    const bookingAnchor = root.querySelector('.at-booking-form-card') || form;
    const unavailableMessage = root.querySelector('[data-at-unavailable-message]');
    const bookingCard = root.querySelector('[data-at-booking-card]');

    if (!roomsNode || !travellersNode || !departure || !submit) return;

    // Variant configuration is product-specific. Missing variants are expected and safe.
    const variantByCategory = {};
    (Array.isArray(productData.variants) ? productData.variants : []).forEach((variant) => {
      const category = categoryFromTitle(variant?.title);
      if (!category) return;
      if (!variantByCategory[category] || (!variantByCategory[category].available && variant.available)) {
        variantByCategory[category] = variant;
      }
    });

    const hasVariant = (category) => Boolean(variantByCategory[category]);
    const isUsable = (variant) => Boolean(variant && variant.available);

    const money = (cents) => new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: productData.currency || 'INR',
      maximumFractionDigits: 0
    }).format((Number(cents) || 0) / 100);

    const adultVariantFor = (room) => (
      room.adults === 1 && room.children === 0
        ? variantByCategory.adult_solo
        : variantByCategory.adult_sharing
    );

    const childVariantFor = (bed) => {
      if (bed && variantByCategory.child_with_bed) return variantByCategory.child_with_bed;
      if (!bed && variantByCategory.child_without_bed) return variantByCategory.child_without_bed;
      if (variantByCategory.child_with_bed) return variantByCategory.child_with_bed;
      return null;
    };

    const childHasBase = () => Boolean(variantByCategory.child_without_bed || variantByCategory.child_with_bed);
    const childBedForced = () => !variantByCategory.child_without_bed || !isUsable(variantByCategory.child_without_bed);

    const infantVariant = () => variantByCategory.infant;

    // Start with two adults when sharing pricing is configured; otherwise retain the single-adult fallback.
    const defaultAdultCount = hasVariant('adult_sharing') ? 2 : 1;
    const rooms = [{ id: 1, adults: defaultAdultCount, children: 0, infants: 0, childAges: [], childBeds: [] }];
    let nextRoomId = 2;
    let travellerSignature = '';
    let lastDate = '';

    const showError = (message, focusTarget) => {
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }

      if (focusTarget) {
        focusTarget.classList.add('at-validation-error');
        const scrollTarget = focusTarget.closest(
          '.at-booking-field, .at-passport-confirmation'
        ) || focusTarget;
        scrollToTarget(root, scrollTarget, false, true);
        window.requestAnimationFrame(() => {
          if (focusTarget.isConnected) focusTarget.focus({ preventScroll: true });
        });
      } else if (error) {
        scrollToTarget(root, error, false, true);
      }
    };
    const clearError = () => {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
    };

    const selectedDeparture = () => calendarValue(departure);
    const dateSelected = () => Boolean(parseDate(selectedDeparture()));
    const roomTotalGuests = (room) => room.adults + room.children + room.infants;
    const roomAdultMode = (room) => (room.adults === 1 && room.children === 0 ? 'solo' : 'sharing');

    const normalizeRoom = (room) => {
      room.adults = Math.max(1, Math.min(3, clampCount(room.adults)));
      room.children = Math.max(0, clampCount(room.children));
      room.infants = Math.max(0, clampCount(room.infants));

      if (!childHasBase()) room.children = 0;
      if (!hasVariant('infant')) room.infants = 0;

      // Without sharing pricing, a room can only contain one adult and no children.
      if (!hasVariant('adult_sharing')) {
        room.adults = Math.min(room.adults, 1);
        room.children = 0;
      }

      const maxChildren = Math.max(0, 4 - room.adults - room.infants);
      room.children = Math.min(room.children, maxChildren);
      if (roomTotalGuests(room) > 4) {
        room.infants = Math.max(0, 4 - room.adults - room.children);
      }

      room.childAges = Array.from({ length: room.children }, (_, index) => {
        const age = clampCount(room.childAges?.[index]);
        return age >= 2 && age <= 11 ? age : 6;
      });
      room.childBeds = Array.from({ length: room.children }, (_, index) => childBedForced() || Boolean(room.childBeds?.[index]));
      return room;
    };

    const snapshotTravellerValues = () => {
      const values = {};
      form.querySelectorAll('input[name], select[name]').forEach((input) => {
        if (input.name === 'departure_date') return;
        values[input.name] = input.type === 'checkbox' ? input.checked : input.value;
      });
      return values;
    };

    const textField = (label, name, attributes = '', type = 'text') => `<label class="at-booking-field"><span>${label} *</span><input type="${type}" name="${name}" required ${attributes}></label>`;

    const canAddAdult = (room) => {
      if (roomTotalGuests(room) >= 4 || room.adults >= 3) return false;
      const nextRoom = { ...room, adults: room.adults + 1 };
      return isUsable(adultVariantFor(nextRoom));
    };

    const canAddChild = (room) => {
      if (roomTotalGuests(room) >= 4 || !childHasBase()) return false;
      if (!isUsable(childVariantFor(childBedForced()))) return false;
      const nextRoom = { ...room, children: room.children + 1 };
      return isUsable(adultVariantFor(nextRoom));
    };

    const canAddInfant = (room) => {
      if (roomTotalGuests(room) >= 4 || !isUsable(infantVariant())) return false;
      return isUsable(adultVariantFor(room));
    };

    const roomCounter = (category, label, age, value, plusDisabled, minusDisabled, locked, variant, suffix = '') => {
      let priceText = 'Not configured';
      if (variant) priceText = variant.available ? `${money(variant.price)}${suffix ? ` · ${suffix}` : ''}` : 'Currently unavailable';
      return `<div class="at-room__guest" data-at-room-row data-category="${category}">
        <div><strong>${label}</strong><small>${age}</small><span data-at-room-price>${priceText}</span></div>
        <div class="at-room-stepper"><button type="button" data-at-room-minus aria-label="Remove ${label.toLowerCase()}" ${minusDisabled ? 'disabled' : ''}>−</button><input type="number" min="${category === 'adults' ? 1 : 0}" max="${category === 'adults' ? 3 : 4}" value="${value}" inputmode="numeric" aria-label="${label} count" data-at-room-count ${locked ? 'disabled' : ''}><button type="button" data-at-room-plus aria-label="Add ${label.toLowerCase()}" ${plusDisabled ? 'disabled' : ''}>+</button></div>
      </div>`;
    };

    const renderRooms = () => {
      const locked = !dateSelected();
      form.classList.toggle('is-date-locked', locked);

      roomsNode.innerHTML = rooms.map((room, roomIndex) => {
        normalizeRoom(room);
        const total = roomTotalGuests(room);
        const adultVariant = adultVariantFor(room);
        const childVariant = childVariantFor(childBedForced());
        const infant = infantVariant();

        const adultPlusDisabled = locked || !canAddAdult(room);
        const childPlusDisabled = locked || !canAddChild(room);
        const infantPlusDisabled = locked || !canAddInfant(room);
        const adultMinusDisabled = locked || room.adults <= 1;
        const childMinusDisabled = locked || room.children <= 0;
        const infantMinusDisabled = locked || room.infants <= 0;

        const childRow = childHasBase()
          ? roomCounter('children', 'Children', '2–11 years', room.children, childPlusDisabled, childMinusDisabled, locked, childVariant, childBedForced() ? 'with bed included' : '')
          : '';
        const infantRow = hasVariant('infant')
          ? roomCounter('infants', 'Infants', '0–1 year', room.infants, infantPlusDisabled, infantMinusDisabled, locked, infant, '')
          : '';

        const notes = [];
        if (!hasVariant('adult_solo') && roomAdultMode(room) === 'solo') notes.push('Single occupancy pricing is not configured for this package.');
        if (!hasVariant('adult_sharing') && (room.adults >= 2 || room.children > 0)) notes.push('Sharing adult pricing is not configured for this package.');
        if (childHasBase() && childBedForced()) notes.push('The available child rate includes an extra bed.');

        return `<div class="at-room" data-room-id="${room.id}">
          <div class="at-room__head">
            <div><strong>Room ${roomIndex + 1}</strong><small>${total} traveller${total === 1 ? '' : 's'} · ${roomAdultMode(room) === 'solo' ? 'Single occupancy' : 'Sharing'}</small></div>
            ${rooms.length > 1 ? `<button type="button" class="at-room__remove" data-at-remove-room>Remove room</button>` : ''}
          </div>
          <div class="at-room__guests">
            ${roomCounter('adults', 'Adults', '12+ years', room.adults, adultPlusDisabled, adultMinusDisabled, locked, adultVariant, '')}
            ${childRow}
            ${infantRow}
          </div>
          ${room.children ? `<div class="at-room__children-ages"><strong>Child ages</strong>${room.childAges.map((age, childIndex) => `<label><span>Child ${childIndex + 1} age</span><select data-at-child-age data-child-index="${childIndex}">${Array.from({ length: 10 }, (_, i) => i + 2).map((value) => `<option value="${value}" ${Number(age) === value ? 'selected' : ''}>${value} years</option>`).join('')}</select></label>`).join('')}</div>` : ''}
          ${notes.length ? `<p class="at-room__note">${notes.join(' ')}</p>` : ''}
          ${locked ? '<p class="at-room__note">Select a departure date to choose travellers for this room.</p>' : ''}
        </div>`;
      }).join('');

      if (addRoom) addRoom.disabled = locked || !(hasVariant('adult_solo') || hasVariant('adult_sharing'));
    };

    const descriptors = () => {
      const list = [];
      rooms.forEach((room, roomIndex) => {
        normalizeRoom(room);
        for (let i = 1; i <= room.adults; i += 1) list.push({ room, roomIndex, category: 'adult', categoryLabel: 'Adult', categoryIndex: i, key: `room${room.id}_adult${i}` });
        for (let i = 1; i <= room.children; i += 1) list.push({ room, roomIndex, category: 'child', categoryLabel: 'Child', categoryIndex: i, key: `room${room.id}_child${i}`, childAge: Number(room.childAges[i - 1] || 6), childBed: childBedForced() || Boolean(room.childBeds[i - 1]) });
        for (let i = 1; i <= room.infants; i += 1) list.push({ room, roomIndex, category: 'infant', categoryLabel: 'Infant', categoryIndex: i, key: `room${room.id}_infant${i}` });
      });
      return list;
    };

    const renderTravellers = () => {
      const list = descriptors();
      const signature = list.map((item) => `${item.key}:${item.category === 'child' ? item.childAge : ''}:${item.category === 'child' ? item.childBed : ''}`).join('|');
      if (signature === travellerSignature) return;
      const previous = snapshotTravellerValues();
      travellerSignature = signature;
      const singleTraveller = list.length === 1;
      const showPrimaryContact = list.length >= 2;
      travellerSection.hidden = list.length === 0;

      if (contactSection) {
        contactSection.hidden = !showPrimaryContact;
        contactSection.querySelectorAll('input, select, textarea').forEach((input) => { input.disabled = !showPrimaryContact; });
      }
      if (travellerStepNumber) travellerStepNumber.textContent = showPrimaryContact ? '4' : '3';
      if (travellerSummary) travellerSummary.textContent = `${list.length} traveller${list.length === 1 ? '' : 's'}`;

      travellersNode.innerHTML = list.map((item, index) => {
        const prefix = `traveller_${item.key}`;
        const roomLabel = `Room ${item.roomIndex + 1}`;
        const bedAvailable = item.category === 'child' && hasVariant('child_without_bed') && hasVariant('child_with_bed');
        const bed = item.category === 'child' && bedAvailable
          ? `<label class="at-traveller__bed"><input type="checkbox" name="${prefix}_extra_bed" value="Yes" data-at-extra-bed ${item.childBed ? 'checked' : ''}><span><span>Add extra bed</span><small>+ ${money(Math.max(0, (variantByCategory.child_with_bed?.price || 0) - (variantByCategory.child_without_bed?.price || 0)))}</small></span></label>`
          : '';
        const forcedBedNote = item.category === 'child' && childBedForced() ? '<span>Extra bed included in the available child rate</span>' : '';

        return `<fieldset class="at-traveller" data-traveller-key="${item.key}">
          <legend>Traveller ${index + 1} · ${item.categoryLabel} ${item.categoryIndex} · ${roomLabel}</legend>
          <div class="at-traveller__meta"><span><strong>${item.categoryLabel}</strong></span>${item.category === 'child' ? `<span>Selected age: ${item.childAge} years</span>${forcedBedNote}` : ''}</div>
          <div class="at-traveller__grid">
            ${textField('First name', `${prefix}_first_name`, 'autocomplete="given-name"')}
            ${textField('Surname', `${prefix}_last_name`, 'autocomplete="family-name"')}
            ${singleTraveller ? `${textField('Email address', `${prefix}_contact_email`, 'autocomplete="email" inputmode="email"', 'email')}${textField('Contact number', `${prefix}_contact_mobile`, 'autocomplete="tel" inputmode="tel" minlength="7" maxlength="20" pattern="[+0-9 ()-]{7,20}" data-at-mobile', 'tel')}` : ''}
            ${textField('Nationality', `${prefix}_nationality`, 'autocomplete="country-name"')}
            ${productData.international ? textField('Passport number', `${prefix}_passport_number`, 'minlength="6" maxlength="12" pattern="[A-Za-z0-9]{6,12}" autocapitalize="characters" spellcheck="false" data-at-passport-number') : ''}
            ${calendarMarkup(`${prefix}_dob`, 'Date of birth', 'dob', item.category === 'adult' ? 'adult' : item.category === 'infant' ? 'infant' : 'child')}
            ${productData.international ? calendarMarkup(`${prefix}_passport_expiry`, 'Passport expiry', 'expiry', item.category) : ''}
            ${bed}
          </div>
        </fieldset>`;
      }).join('');

      travellersNode.querySelectorAll('input[name], select[name]').forEach((input) => {
        if (Object.prototype.hasOwnProperty.call(previous, input.name)) input.checked = input.type === 'checkbox' ? Boolean(previous[input.name]) : previous[input.name];
      });
      travellersNode.querySelectorAll('[data-at-calendar]').forEach((calendar) => new CustomCalendar(calendar, clearError));
    };

    const pricing = () => {
      let total = 0;
      const summaryRooms = [];
      rooms.forEach((room, roomIndex) => {
        normalizeRoom(room);
        const adultVariant = adultVariantFor(room);
        const children = Array.from({ length: room.children }, (_, index) => {
          const forced = childBedForced();
          const key = `traveller_room${room.id}_child${index + 1}_extra_bed`;
          const checked = forced || form.querySelector(`[name="${key}"]`)?.checked || Boolean(room.childBeds[index]);
          return { bed: checked, variant: childVariantFor(checked) };
        });
        const infant = infantVariant();
        const roomAdultTotal = isUsable(adultVariant) ? Number(adultVariant.price) * room.adults : 0;
        const childTotal = children.reduce((sum, child) => sum + (isUsable(child.variant) ? Number(child.variant.price) : 0), 0);
        const infantTotal = room.infants && isUsable(infant) ? Number(infant.price) * room.infants : 0;
        const roomTotal = roomAdultTotal + childTotal + infantTotal;
        total += roomTotal;
        summaryRooms.push({ room, roomIndex, roomTotal, adultVariant, children, infantVariant: infant, infantTotal });
      });
      return { total, summaryRooms };
    };

    const roomHasConfiguredPricing = (room) => {
      const adultVariant = adultVariantFor(room);
      if (!isUsable(adultVariant)) return false;
      if (room.infants && !isUsable(infantVariant())) return false;
      for (let index = 0; index < room.children; index += 1) {
        const bed = childBedForced() || Boolean(room.childBeds[index]) || Boolean(form.querySelector(`[name="traveller_room${room.id}_child${index + 1}_extra_bed"]`)?.checked);
        if (!isUsable(childVariantFor(bed))) return false;
      }
      return true;
    };

    const updateSummary = () => {
      rooms.forEach(normalizeRoom);
      const list = descriptors();
      const { total, summaryRooms } = pricing();
      if (roomSummary) roomSummary.textContent = `${rooms.length} room${rooms.length === 1 ? '' : 's'} · ${list.length} traveller${list.length === 1 ? '' : 's'}`;
      if (totalNode) totalNode.textContent = money(total);
      if (totalGuestsNode) totalGuestsNode.textContent = `${list.length} traveller${list.length === 1 ? '' : 's'}`;
      if (dockTotal) dockTotal.textContent = money(total);
      if (dockGuests) dockGuests.textContent = `${list.length} traveller${list.length === 1 ? '' : 's'}`;

      if (selectedNode) {
        selectedNode.innerHTML = summaryRooms.map(({ room, roomIndex, roomTotal, adultVariant, children, infantVariant: infant }) => {
          const parts = [];
          if (room.adults) parts.push(`${room.adults} Adult${room.adults === 1 ? '' : 's'} × ${money(adultVariant?.price || 0)}`);
          if (room.children) {
            const withBed = children.filter((child) => child.bed).length;
            const withoutBed = room.children - withBed;
            if (withoutBed) parts.push(`${withoutBed} Child${withoutBed === 1 ? '' : 'ren'} × ${money(variantByCategory.child_without_bed?.price || 0)}`);
            if (withBed) parts.push(`${withBed} Child${withBed === 1 ? '' : 'ren'} + bed × ${money(variantByCategory.child_with_bed?.price || 0)}`);
          }
          if (room.infants) parts.push(`${room.infants} Infant${room.infants === 1 ? '' : 's'} × ${money(infant?.price || 0)}`);
          return `<div class="at-booking-summary__room"><div class="at-booking-summary__room-head"><span>Room ${roomIndex + 1}</span><strong>${money(roomTotal)}</strong></div><div class="at-booking-summary__room-list">${parts.join('<br>')}</div></div>`;
        }).join('');
      }

      const allVariantsConfigured = Object.keys(variantByCategory).length > 0;
      const allAvailable = allVariantsConfigured && rooms.every(roomHasConfiguredPricing);
      const hasGuests = list.length > 0;
      submit.disabled = !dateSelected() || !hasGuests || !allAvailable;
      if (unavailableMessage) unavailableMessage.hidden = allAvailable;

      renderTravellers();
      renderRooms();
    };

    const handleRoomChange = (room, category, delta) => {
      if (delta > 0) {
        if (category === 'adults' && !canAddAdult(room)) return;
        if (category === 'children' && !canAddChild(room)) return;
        if (category === 'infants' && !canAddInfant(room)) return;
      }

      if (category === 'adults') room.adults = Math.max(1, Math.min(3, clampCount(room.adults) + delta));
      if (category === 'children') room.children = Math.max(0, clampCount(room.children) + delta);
      if (category === 'infants') room.infants = Math.max(0, clampCount(room.infants) + delta);
      normalizeRoom(room);
      clearError();
      updateSummary();
    };

    form.querySelector('[data-at-calendar]') && new CustomCalendar(form.querySelector('[data-at-calendar]'), () => {
      if (lastDate !== selectedDeparture()) {
        lastDate = selectedDeparture();
        updateSummary();
      }
      clearError();
    });

    roomsNode.addEventListener('click', (event) => {
      const roomNode = event.target.closest('[data-room-id]');
      if (!roomNode || !dateSelected()) return;
      const room = rooms.find((item) => String(item.id) === roomNode.dataset.roomId);
      if (!room) return;

      const remove = event.target.closest('[data-at-remove-room]');
      if (remove) {
        const index = rooms.findIndex((item) => item.id === room.id);
        if (index > 0) rooms.splice(index, 1);
        updateSummary();
        return;
      }

      const row = event.target.closest('[data-at-room-row]');
      if (!row) return;
      const category = row.dataset.category;
      if (event.target.closest('[data-at-room-minus]')) handleRoomChange(room, category, -1);
      if (event.target.closest('[data-at-room-plus]')) handleRoomChange(room, category, 1);
    });

    roomsNode.addEventListener('change', (event) => {
      const roomNode = event.target.closest('[data-room-id]');
      if (!roomNode) return;
      const room = rooms.find((item) => String(item.id) === roomNode.dataset.roomId);
      if (!room) return;

      if (event.target.matches('[data-at-room-count]')) {
        const row = event.target.closest('[data-at-room-row]');
        const category = row?.dataset.category;
        if (!category) return;
        const requested = clampCount(event.target.value);
        if (category === 'adults') room.adults = Math.max(1, Math.min(3, requested));
        if (category === 'children') room.children = requested;
        if (category === 'infants') room.infants = requested;
        normalizeRoom(room);
        updateSummary();
      }

      if (event.target.matches('[data-at-child-age]')) {
        room.childAges[Number(event.target.dataset.childIndex)] = Number(event.target.value);
        updateSummary();
      }
    });

    addRoom?.addEventListener('click', () => {
      if (!dateSelected() || !(hasVariant('adult_solo') || hasVariant('adult_sharing'))) return;
      rooms.push({ id: nextRoomId++, adults: 1, children: 0, infants: 0, childAges: [], childBeds: [] });
      updateSummary();
    });

    form.addEventListener('input', (event) => {
      if (event.target.matches('input, select, textarea')) {
        event.target.classList.remove('at-validation-error');
      }

      if (event.target.matches('[data-at-mobile]')) event.target.value = event.target.value.replace(/[^+0-9 ()-]/g, '').slice(0, 20);
      if (event.target.matches('[data-at-passport-number]')) event.target.value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
      if (event.target.matches('[data-at-extra-bed]')) {
        const traveller = event.target.closest('[data-at-traveller-key]');
        const match = traveller?.dataset.travellerKey?.match(/room(\d+)_child(\d+)/);
        if (match) {
          const room = rooms.find((item) => item.id === Number(match[1]));
          if (room) room.childBeds[Number(match[2]) - 1] = event.target.checked;
        }
        updateSummary();
      }
    });

    const ageOnDate = (dob, onDate) => {
      let age = onDate.getFullYear() - dob.getFullYear();
      if (onDate.getMonth() < dob.getMonth() || (onDate.getMonth() === dob.getMonth() && onDate.getDate() < dob.getDate())) age -= 1;
      return age;
    };

    const markValidationError = (field) => {
      if (!field) return;
      field.classList.add('at-validation-error');
    };

    const clearValidationErrors = () => {
      form.querySelectorAll('.at-validation-error').forEach((field) => {
        field.classList.remove('at-validation-error');
      });
    };

    const firstInvalidField = () => form.querySelector(
      'input:not([type="hidden"]):not(:disabled):invalid, select:not(:disabled):invalid, textarea:not(:disabled):invalid'
    );

    const focusInvalidField = (field) => {
      if (!field) return;

      markValidationError(field);

      window.requestAnimationFrame(() => {
        field.focus({ preventScroll: true });

        /*
         * Do not call reportValidity() here.
         * The browser's native validation tooltip can otherwise appear
         * before our custom error styling and make the validation flow
         * jump to the wrong field.
         */
      });
    };

    const validate = () => {
      clearError();
      clearValidationErrors();

      const departureDate = parseDate(selectedDeparture());

      if (!departureDate) {
        showError(
          'Please select a departure date.',
          form.querySelector('[data-at-calendar-trigger]')
        );
        return false;
      }

      /*
       * 1. Validate room configuration.
       */
      for (let roomIndex = 0; roomIndex < rooms.length; roomIndex += 1) {
        const room = normalizeRoom(rooms[roomIndex]);

        if (room.adults < 1) {
          showError(`Room ${roomIndex + 1} must have at least 1 adult.`);
          return false;
        }

        if (roomTotalGuests(room) > 4 || room.adults > 3) {
          showError(
            `Room ${roomIndex + 1} can have a maximum of 4 travellers, including a maximum of 3 adults.`
          );
          return false;
        }

        if (!roomHasConfiguredPricing(room)) {
          const adultVariant = adultVariantFor(room);

          if (!adultVariant) {
            showError(
              `The required adult pricing for Room ${roomIndex + 1} is not configured for this package.`
            );
            return false;
          }

          if (!adultVariant.available) {
            showError(
              `Adult pricing for Room ${roomIndex + 1} is currently unavailable.`
            );
            return false;
          }

          if (room.children) {
            showError(
              `Child pricing for Room ${roomIndex + 1} is not available for the selected bed option.`
            );
            return false;
          }

          if (room.infants && !isUsable(infantVariant())) {
            showError('Infant pricing is not available for this package.');
            return false;
          }

          return false;
        }
      }

      const list = descriptors();

      if (!list.length) {
        showError('Please add at least one traveller.');
        return false;
      }

      /*
       * 2. Validate required traveller fields in DOM order.
       *
       * This intentionally happens BEFORE contact-number validation.
       * Therefore the user gets:
       *
       * First name
       * -> Surname
       * -> Email
       * -> Contact number
       * -> Nationality
       * -> Passport number
       * -> DOB
       * -> Passport expiry
       *
       * instead of jumping directly to contact number.
       */
      const invalid = firstInvalidField();

      if (invalid) {
        const isMobile = invalid.matches('[data-at-mobile]');

        markValidationError(invalid);

        showError(
          isMobile
            ? 'Please enter a valid contact number, including the country code when needed.'
            : 'Please complete this field.',
          invalid
        );

        focusInvalidField(invalid);
        return false;
      }

      /*
       * 3. Extra contact-number validation.
       *
       * This catches values that may pass the browser's basic
       * required/pattern state but do not contain a valid international-length number.
       */
      const activeMobileInput =
        form.querySelector('[data-at-mobile]:not(:disabled)');

      if (
        activeMobileInput &&
        !/^\d{7,15}$/.test((activeMobileInput.value || '').replace(/\D/g, ''))
      ) {
        markValidationError(activeMobileInput);

        showError(
          'Please enter a valid contact number, including the country code when needed.',
          activeMobileInput
        );

        focusInvalidField(activeMobileInput);
        return false;
      }

      /*
       * 4. Validate DOB, age and passport details.
       */
      for (let index = 0; index < list.length; index += 1) {
        const item = list[index];
        const prefix = `traveller_${item.key}`;

        const dobInput = form.querySelector(
          `[name="${prefix}_dob"]`
        );

        const dob = parseDate(
          calendarValue(dobInput)
        );

        if (!dob) {
          showError(
            `Please select the date of birth for Traveller ${index + 1}.`,
            dobInput
              ?.closest('[data-at-calendar]')
              ?.querySelector('[data-at-calendar-trigger]')
          );
          return false;
        }

        const age = ageOnDate(dob, departureDate);

        const validAge =
          item.category === 'adult'
            ? age >= 12
            : item.category === 'infant'
              ? age >= 0 && age < 2
              : age >= 2 && age < 12;

        if (!validAge) {
          showError(
            `Traveller ${index + 1} does not match the selected ${item.categoryLabel} age range on the departure date.`,
            dobInput
              ?.closest('[data-at-calendar]')
              ?.querySelector('[data-at-calendar-trigger]')
          );
          return false;
        }

        if (
          item.category === 'child' &&
          age !== item.childAge
        ) {
          showError(
            `Traveller ${index + 1} age does not match the selected age for ${item.categoryLabel} ${item.categoryIndex} in Room ${item.roomIndex + 1}.`,
            dobInput
              ?.closest('[data-at-calendar]')
              ?.querySelector('[data-at-calendar-trigger]')
          );
          return false;
        }

        if (productData.international) {
          const expiryInput = form.querySelector(
            `[name="${prefix}_passport_expiry"]`
          );

          const expiry = parseDate(
            calendarValue(expiryInput)
          );

          if (!expiry) {
            showError(
              `Please select the passport expiry date for Traveller ${index + 1}.`,
              expiryInput
                ?.closest('[data-at-calendar]')
                ?.querySelector('[data-at-calendar-trigger]')
            );
            return false;
          }
        }
      }

      return true;
    };

    const bookingProperties = (data, list, groupId, summaryRooms) => {
      const properties = {
        '_Booking group': groupId,
        'Departure date': selectedDeparture(),
        'Room count': String(rooms.length),
        'Traveller count': String(list.length),
        'Room allocation': summaryRooms.map(({ room, roomIndex }) => `Room ${roomIndex + 1}: ${room.adults} Adult${room.adults === 1 ? '' : 's'}, ${room.children} Child${room.children === 1 ? '' : 'ren'}, ${room.infants} Infant${room.infants === 1 ? '' : 's'}`).join(' | '),
        'Booking contact': list.length === 1
          ? `${String(data.get(`traveller_${list[0].key}_first_name`) || '')} ${String(data.get(`traveller_${list[0].key}_last_name`) || '')}`.trim()
          : String(data.get('contact_first_name') || '').trim(),
        'Contact mobile': list.length === 1 ? String(data.get(`traveller_${list[0].key}_contact_mobile`) || '') : String(data.get('contact_mobile') || ''),
        'Contact email': list.length === 1 ? String(data.get(`traveller_${list[0].key}_contact_email`) || '') : String(data.get('contact_email') || '')
      };
      list.forEach((item, index) => {
        const prefix = `traveller_${item.key}`;
        const extraBed = item.category === 'child' && (data.get(`${prefix}_extra_bed`) === 'Yes' || item.childBed) ? 'Extra bed: Yes' : '';
        const details = [
          `Room ${item.roomIndex + 1}`,
          item.categoryLabel,
          `${String(data.get(`${prefix}_first_name`) || '')} ${String(data.get(`${prefix}_last_name`) || '')}`.trim(),
          `DOB: ${calendarValue(form.querySelector(`[name="${prefix}_dob"]`))}`,
          `Nationality: ${String(data.get(`${prefix}_nationality`) || '')}`,
          extraBed
        ].filter(Boolean);
        if (item.category === 'child') details.splice(2, 0, `Age: ${item.childAge}`);
        if (productData.international) {
          details.push(`Passport: ${String(data.get(`${prefix}_passport_number`) || '')}`);
          details.push(`Expiry: ${calendarValue(form.querySelector(`[name="${prefix}_passport_expiry"]`))}`);
        }
        properties[`_Traveller ${index + 1}`] = details.join(' | ');
      });
      if (productData.international) properties['Passport data consent'] = 'Accepted';
      return properties;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!validate()) return;

      const list = descriptors();
      const data = new FormData(form);
      const groupId = `AT-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
      const { summaryRooms } = pricing();
      const master = bookingProperties(data, list, groupId, summaryRooms);
      const items = [];
      let masterAttached = false;

      summaryRooms.forEach(({ room, roomIndex, children }) => {
        const roomPrefix = `Room ${roomIndex + 1}`;
        const adultVariant = adultVariantFor(room);
        if (room.adults && adultVariant) {
          const categoryLabel = roomAdultMode(room) === 'solo' ? 'Adult - Single/Solo' : 'Adult - Sharing';
          const properties = masterAttached
            ? { '_Booking group': groupId, 'Departure date': selectedDeparture(), 'Room': roomPrefix, 'Traveller category': categoryLabel }
            : { ...master, 'Room': roomPrefix, 'Traveller category': categoryLabel };
          items.push({ id: adultVariant.id, quantity: room.adults, properties });
          masterAttached = true;
        }

        const childBuckets = { without: [], with: [] };
        children.forEach((child, index) => childBuckets[child.bed ? 'with' : 'without'].push(index + 1));

        if (childBuckets.without.length) {
          const variant = variantByCategory.child_without_bed;
          if (!variant) throw new Error('Child without-bed pricing is not configured.');
          const properties = masterAttached
            ? { '_Booking group': groupId, 'Departure date': selectedDeparture(), 'Room': roomPrefix, 'Traveller category': 'Child - without bed', 'Child numbers': childBuckets.without.join(', ') }
            : { ...master, 'Room': roomPrefix, 'Traveller category': 'Child - without bed', 'Child numbers': childBuckets.without.join(', ') };
          items.push({ id: variant.id, quantity: childBuckets.without.length, properties });
          masterAttached = true;
        }

        if (childBuckets.with.length) {
          const variant = variantByCategory.child_with_bed;
          if (!variant) throw new Error('Child with-bed pricing is not configured.');
          const properties = masterAttached
            ? { '_Booking group': groupId, 'Departure date': selectedDeparture(), 'Room': roomPrefix, 'Traveller category': 'Child - with bed', 'Child numbers': childBuckets.with.join(', ') }
            : { ...master, 'Room': roomPrefix, 'Traveller category': 'Child - with bed', 'Child numbers': childBuckets.with.join(', ') };
          items.push({ id: variant.id, quantity: childBuckets.with.length, properties });
          masterAttached = true;
        }

        if (room.infants) {
          const variant = variantByCategory.infant;
          if (!variant) throw new Error('Infant pricing is not configured.');
          const properties = masterAttached
            ? { '_Booking group': groupId, 'Departure date': selectedDeparture(), 'Room': roomPrefix, 'Traveller category': 'Infant' }
            : { ...master, 'Room': roomPrefix, 'Traveller category': 'Infant' };
          items.push({ id: variant.id, quantity: room.infants, properties });
          masterAttached = true;
        }
      });

      if (!items.length) {
        showError('This package does not have the pricing variants required for the selected booking. Please talk to an expert.');
        return;
      }

      const original = submit.innerHTML;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Preparing secure checkout…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this booking.');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (exception) {
        showError(exception.message || 'Something went wrong. Please try again.');
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.innerHTML = original;
      }
    });

    const focusBooking = () => {
      scrollToTarget(root, bookingAnchor, false, true);
      window.setTimeout(() => {
        const focusTarget = !dateSelected()
          ? form.querySelector('[data-at-calendar-trigger]')
          : form.querySelector('input[name*="_first_name"]:not(:disabled), input[name="contact_first_name"]:not(:disabled)');
        focusTarget?.focus({ preventScroll: true });
      }, 450);
    };
    dockBook?.addEventListener('click', () => {
      if (submit.getAttribute('aria-busy') === 'true') return;
      form.requestSubmit(submit);
    });
    root.querySelectorAll('[data-at-booking-link]').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); focusBooking(); }));

    const toggleDock = () => {
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      const footer = document.querySelector(
        '.shopify-section-group-footer-group, footer, [data-section-type="footer"]'
      );
      const footerClear = !footer || footer.getBoundingClientRect().top >
        window.innerHeight - (mobile ? 0 : 10);

      const buttonRect = submit.getBoundingClientRect();
      const mainButtonVisible = buttonRect.height > 0 &&
        buttonRect.bottom > visibleHeaderOffset(root) &&
        buttonRect.top < window.innerHeight;

      const summaryAboveViewport = bookingCard &&
        bookingCard.getBoundingClientRect().bottom <= visibleHeaderOffset(root);

      const mobileBarVisible = Boolean(
        mobile && root.isConnected && dock && footerClear && !mainButtonVisible
      );

      const dockVisible = mobile
        ? mobileBarVisible
        : Boolean(summaryAboveViewport && footerClear);

      dock?.classList.toggle('is-visible', dockVisible);
      dock?.classList.toggle('is-mobile-hidden', mobile && !mobileBarVisible);

      if (dock) {
        dock.inert = !dockVisible;
        dock.setAttribute('aria-hidden', String(!dockVisible));
      }

      document.querySelectorAll('.stickywhatspp').forEach((element) => {
        element.classList.toggle('mobile-bar-visible', mobileBarVisible);
      });
    };

    window.addEventListener('scroll', toggleDock, { passive: true });
    window.addEventListener('resize', toggleDock, { passive: true });
    renderRooms();
    updateSummary();
    toggleDock();
  };
  const initShare = (root, productData) => {
    const shareData = {
      title: productData.productTitle || document.title,
      text: 'Explore ' + (productData.productTitle || 'this Adventure Tales package'),
      url: productData.productUrl || window.location.href
    };

    root.querySelectorAll('[data-at-share]').forEach((button) => {
      if (button.dataset.atShareReady === 'true') return;
      button.dataset.atShareReady = 'true';

      const group = button.closest(
        '.at-package-hero__actions, .at-booking-dock__content'
      ) || button.parentElement;
      let status = group?.querySelector('[data-at-share-status]');

      if (!status && group) {
        status = document.createElement('span');
        status.className = 'at-share-status';
        status.setAttribute('data-at-share-status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        group.append(status);
      }

      let resetTimer = 0;

      const copyLink = async () => {
        try {
          let copied = false;

          if (navigator.clipboard?.writeText) {
            try {
              await navigator.clipboard.writeText(shareData.url);
              copied = true;
            } catch {}
          }

          if (!copied) {
            const helper = document.createElement('textarea');
            const focused = document.activeElement;
            helper.value = shareData.url;
            helper.setAttribute('readonly', '');
            helper.style.position = 'fixed';
            helper.style.opacity = '0';
            document.body.append(helper);

            try {
              helper.select();
              copied = document.execCommand('copy');
            } finally {
              helper.remove();
              focused?.focus({ preventScroll: true });
            }
          }

          if (!copied) throw new Error('Copy unavailable');
          if (status) status.textContent = 'Package link copied';
          button.classList.add('is-copied');
          window.clearTimeout(resetTimer);
          resetTimer = window.setTimeout(() => {
            button.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 2200);
        } catch {
          if (status) status.textContent = 'Copy this link: ' + shareData.url;
        }
      };

      button.addEventListener('click', async () => {
        if (navigator.share) {
          try {
            await navigator.share(shareData);
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }
        await copyLink();
      });
    });
  };

  const initItinerary = (root) => {
    const browser = root.querySelector('[data-at-itinerary]');
    if (!browser || browser.dataset.atItineraryReady === 'true') return;
    const tabs = [...browser.querySelectorAll('[data-at-itinerary-tab]')];
    const panels = [...browser.querySelectorAll('[data-at-itinerary-panel]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    browser.dataset.atItineraryReady = 'true';

    const activate = (index, moveFocus = false) => {
      const selected = Math.max(0, Math.min(index, tabs.length - 1));
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === selected;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === selected;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      tabs[selected].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (moveFocus) tabs[selected].focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') activate(0, true);
        else if (event.key === 'End') activate(tabs.length - 1, true);
        else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') activate((index + 1) % tabs.length, true);
        else activate((index - 1 + tabs.length) % tabs.length, true);
      });
    });
  };

  const initSimilarSlider = (section) => {
    if (!section || section.dataset.atSliderReady === 'true') return;
    const track = section.querySelector('[data-at-similar-track]');
    const previous = section.querySelector('[data-at-similar-previous]');
    const next = section.querySelector('[data-at-similar-next]');
    const controls = section.querySelector('[data-at-similar-controls]');
    if (!track) return;
    section.dataset.atSliderReady = 'true';

    const step = () => {
      const card = track.querySelector('[data-at-similar-card]');
      if (!card) return track.clientWidth;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const updateControls = () => {
      const overflow = track.scrollWidth > track.clientWidth + 2;
      if (controls) controls.hidden = !overflow;
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    previous?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  const initRecommendations = (scope = document) => {
    if (scope.matches?.('[data-at-similar-slider]')) initSimilarSlider(scope);
    scope.querySelectorAll('[data-at-similar-slider]').forEach(initSimilarSlider);
    const loaders = [
      ...(scope.matches?.('[data-at-recommendations-url]') ? [scope] : []),
      ...scope.querySelectorAll('[data-at-recommendations-url]')
    ];
    loaders.forEach((loader) => {
      if (loader.dataset.atLoading === 'true') return;
      loader.dataset.atLoading = 'true';
      fetch(loader.dataset.atRecommendationsUrl, { headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const replacement = documentFragment.querySelector('[data-at-similar-recommendations]');
          const slider = replacement?.matches('[data-at-similar-slider]')
            ? replacement
            : replacement?.querySelector('[data-at-similar-slider]');
          if (!replacement || !slider) {
            loader.remove();
            return;
          }
          loader.replaceWith(replacement);
          initSimilarSlider(slider);
        })
        .catch(() => loader.remove());
    });
  };

  const init = (root) => {
    if (root.dataset.atReady === 'true') return;
    root.dataset.atReady = 'true';
    const productDataNode = root.querySelector('[data-at-product-data]');
    if (!productDataNode) return;
    let productData;
    try { productData = JSON.parse(productDataNode.textContent); }
    catch (error) { console.error('Adventure Tales booking data could not be read.', error); return; }

    initBooking(root, productData);
    initShare(root, productData);
    initItinerary(root);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-at-package-product]')) init(scope);
    scope.querySelectorAll('[data-at-package-product]').forEach(init);
  };
  const start = (scope = document) => {
    initAll(scope);
    if (scope.matches?.('[data-at-gallery]')) initGallery(scope);
    scope.querySelectorAll('[data-at-gallery]').forEach(initGallery);
    initRecommendations(scope);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();